<template>
  <img v-if="modelValue?.path"
       class="min-w-10 w-10 min-h-10 h-10
        rounded-full object-cover
        border-2 border-white border-solid"
       :src="modelValue.path"
       :alt="modelValue.name"/>
  <template v-else>
    <div  class="md:hidden">
      <p-icon icon-name="profile"
              size="large"
              color="white"/>
    </div>
    <div class="hidden md:inline-block">
      <p-icon icon-name="profile"
              size="large"
              color="blue"/>
    </div>
  </template>
</template>

<script setup lang="ts">
defineProps<{
  modelValue: any
}>();
</script>
